import React from "react";
import styled from "styled-components";
import { useDraggable } from "../../../utils/hooks";

interface BottomSectionV2Props {
  children: React.ReactNode;
}

export const BottomFloatingSection: React.FC<BottomSectionV2Props> = ({ children }) => {
  const { draggableRef, handleDragStart, dragState } = useDraggable({
    resetPositionOnViewportChange: {
      type: "custom",
      position: { x: "50%", y: "100%" },
    },
  });

  return (
    <Container ref={draggableRef} onMouseDown={handleDragStart}>
      {children}
    </Container>
  );
};

const Container = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: 100px;
  overflow: visible;
`;
